<template>
    <DsModal
        is-open
        class="integration-modal"
        data-qa="integration-modal"
        :show-close="!isInternal"
        :show-save="!isInternal"
        :size="size"
        @close="closeModal"
    >
        <template v-if="!isInternal" #header>
            <DsFilledButton
                v-if="isInternal"
                data-qa="goal-modal-save-button"
                @click="updateConfig"
            >
                <template #default>
                    {{ $t('funnel.edit.done') }}
                </template>
            </DsFilledButton>
        </template>
        <template #default>
            <component
                :is="integrationComponent"
                v-if="isInternal"
                :cell="cell"
                :app-info="appInfo"
                :funnel-id="funnelId"
                :modal-title="cell.value.name"
                @update-internal-config="updateInternalConfig"
                @close-modal="closeModal"
            />
            <iframe
                v-else
                ref="iframeRef"
                class="external-config-frame"
                :src="iframeUrl"
            />
        </template>
    </DsModal>
</template>

<script>

import IntegrationModals from '../../../integrations';

const MESSAGE_TYPES = {
    LOADED: 'loaded',
    SAVE: 'save',
    CLOSE: 'close',
    STATUS: 'status',
};

export default {
    props: {
        enabledIntegrations: {
            type: Array,
            default: () => [],
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                },
            }),
        },
        appInfo: {
            type: Object,
            required: true,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
    },

    emits: ['update-cell-value', 'close-modal'],

    computed: {
        iframeUrl() {
            const url = new URL(this.enabledIntegrations.find((integration) => integration.id === this.cell.value.integrationActionId)?.appBaseUrl);

            return url.toString();
        },

        isInternal() {
            return this.enabledIntegrations.find((integration) => integration.id === this.cell.value.integrationActionId)?.internal;
        },

        integrationThen() {
            return this.enabledIntegrations.find((integration) => integration.id === this.cell.value.integrationActionId);
        },

        integrationComponent() {
            return IntegrationModals[this.integrationThen?.id].component;
        },
        size() {
            return IntegrationModals[this.integrationThen?.id].size || 'med';
        },
    },

    async mounted () {
        window.addEventListener('message', this.receiveMessage);
    },

    beforeUnmount () {
        window.removeEventListener('message', this.receiveMessage);
    },

    methods: {
        receiveMessage (event) {
            const { data: { type } } = event;

            if (type === MESSAGE_TYPES.CLOSE) {
                this.closeModal();
            } else if (type === MESSAGE_TYPES.SAVE) {
                const {
                    data: {
                        ready,
                    },
                } = event;

                this.updateConfig(ready);
            } else if (type === MESSAGE_TYPES.LOADED) {
                const message = {
                    type: 'init',
                    ready: this.cell.isReady ? this.cell.isReady : 0,
                };

                this.$refs.iframeRef.contentWindow.postMessage(message, '*');
            } else if (type === MESSAGE_TYPES.STATUS) {
                const { data: { ready } } = event;

                this.updateReady(ready);
            }
        },

        closeModal() {
            this.$emit('close-modal');
        },

        updateInternalConfig(event) {
            const { data: { externalId, error } } = event;
            const updatedCell = { ...this.cell };

            updatedCell.value.externalId = externalId;

            if (!error) {
                this.$emit('update-cell-value', { cell: updatedCell, isReady: true });
            }
        },

        async updateConfig(isReady) {
            const updatedCell = { ...this.cell };

            try {
                this.$emit('update-cell-value', { cell: updatedCell, isReady });
            } catch (e) {
                const message = {
                    type: 'error',
                    errorMessage: e.response.data,
                };

                this.$refs.iframeRef.contentWindow.postMessage(message, '*');
            }
        },

        updateReady(isReady) {
            const updatedCell = { ...this.cell };

            this.$emit('update-cell-value', { cell: updatedCell, preventClose: true, isReady });
        },
    },
};
</script>

<style lang="scss" scoped>
.integration-modal {
    --modal-padding: 0;
    padding: 0;
}

.external-config-frame {
    width: 100%;
    height: 75vh;
}
.integration-modal ::v-deep .modal-body {
    padding: 0;
}
</style>
